// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M14 12L9.49999 7.5L3 7.5L3 16.5L9.5 16.5L14 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"component-breadcrumb"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14 12L9.49999 7.5L3 7.5L3 16.5L9.5 16.5L14 12Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 12L9.49999 7.5L3 7.5L3 16.5L9.5 16.5L14 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 7.5L20.5 12L16 16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ComponentBreadcrumbIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-breadcrumb',
    ref,
    icon: element,
  },
));

ComponentBreadcrumbIcon.displayName = 'ComponentBreadcrumbIcon';

export default ComponentBreadcrumbIcon;
